import React from "react";
import OnboardAuthLayout from "../../Components/Layouts/OnboardLayout/OnboardAuthLayout";
import { useSelector } from "react-redux";
import { Path } from "../Constant/RoutePaths";
import { Navigate } from "react-router-dom";

const Public = () => {
  const auth = localStorage.getItem("jwt_token");
  return auth ? (
    <Navigate to={Path.DASHBOARD} replace={true} /> // private
  ) : (
    <OnboardAuthLayout />
  );
};

export default Public;